import { ConfirmationDialog } from '@fortem-monorepo/react-ui'

import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'
import { useDeleteEventMutation } from '@/pages/instruments/market-summary/market-summary.mutations'

export interface RemoveEventDialogProps {
  open: boolean
  onClose: () => void
  mutationParams: { event_id: number }
}

export const RemoveEventDialog = ({ open, onClose, mutationParams }: RemoveEventDialogProps) => {
  const { eventsQuery, hasWriteAccess } = useMarketSummaryContext()
  const event = eventsQuery.data?.find((row) => row.event_id === mutationParams.event_id)
  const mutation = useDeleteEventMutation()

  return (
    <ConfirmationDialog
      open={open}
      title="Delete Event"
      description="This deletes the event and removes its metrics from every Market Summary display."
      pending={mutation.isPending}
      valid={hasWriteAccess}
      onClose={() => {
        if (!mutation.isPending) onClose()
      }}
      action={() => {
        if (!hasWriteAccess || mutation.isPending) return
        mutation.mutate(mutationParams, { onSuccess: onClose })
      }}
    >
      <p className="text-sm font-medium">{event?.name ?? `Event ${mutationParams.event_id}`}</p>
      {event && (
        <p className="text-sm text-muted-foreground">
          {event.st_dt} to {event.ed_dt ?? 'present'}
        </p>
      )}
    </ConfirmationDialog>
  )
}
